// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"133":"css/stockbee/stockbee","170":"css/app","926":"css/shop/shop"}[chunkId] + ".css";
};